var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 39.5833L7.89583 43.2021C7.70777 43.2649 7.50747 43.282 7.31147 43.2521C7.11547 43.2222 6.92939 43.1461 6.76861 43.0301C6.60782 42.9141 6.47694 42.7615 6.38676 42.5849C6.29659 42.4083 6.24971 42.2128 6.25 42.0146V11.3187C6.25005 11.0565 6.33256 10.801 6.48585 10.5882C6.63914 10.3755 6.85545 10.2164 7.10417 10.1333L18.75 6.25M18.75 39.5833L31.25 43.75M18.75 39.5833V6.25M18.75 6.25L31.25 10.4167M31.25 43.75L42.8958 39.8687C43.1449 39.7856 43.3614 39.6261 43.5148 39.413C43.6681 39.1998 43.7504 38.9438 43.75 38.6812V7.98333C43.75 7.78524 43.7028 7.58999 43.6125 7.41369C43.5222 7.23738 43.3913 7.08506 43.2305 6.96929C43.0698 6.85352 42.8839 6.77761 42.688 6.74781C42.4922 6.71801 42.2921 6.73519 42.1042 6.79792L31.25 10.4167M31.25 43.75V10.4167",
    stroke: "#1351D8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.b6bba2b6403e8b16ac5ba1f203c77d63.svg";
export { ForwardRef as ReactComponent };